<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col class="d-inline-flex">
          <v-text-field dense label="identityNo" outlined hide-details v-model="filters.identityNo"></v-text-field>
          <v-btn class="ml-2" color="primary" @click="filter">검색</v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-data-table
      :items="items"
      :items-per-page="-1"
      :headers="headers"
    >
      <template v-slot:item.date="{ item }">
        {{ $moment(item.date).format('YY-MM-DD HH:mm:ss') }}
      </template>
      <template v-slot:item.createdAt="{ item }">
        {{ dateFromObjectId(item._id) }}
      </template>
      <template v-slot:item.packet="{ item }">
        <v-btn @click="show(item.packet.data)">보기</v-btn>
      </template>
    </v-data-table>

    <v-btn @click="move(pagination.page + 1)">더보기</v-btn>
  </div>
</template>

<script>
import { getPackets } from '@/api'
// import { getPaginationParams } from '@/utils'

export default {
  data () {
    return {
      packets: [],
      count: 0,
      loading: false,
      headers: [
        {
          text: 'identityNo',
          value: 'identityNo'
        },
        {
          text: 'command',
          value: 'command'
        },
        {
          text: 'index',
          value: 'index'
        },
        {
          text: 'count',
          value: 'count'
        },
        {
          text: 'date',
          value: 'date'
        },
        {
          text: 'createdAt',
          value: 'createdAt'
        },
        {
          text: 'packet',
          value: 'packet'
        }
      ],
      pagination: {
        page: 1,
        itemsPerPage: 180
      },
      filters: {
        identityNo: ''
      }
    }
  },
  computed: {
    items () {
      return this.packets
    }
  },
  async beforeRouteEnter (to, from, next) {
    let page = parseInt(to.query.page, 10) || 1
    if (page < 1) page = 1

    const query = {}
    const limit = 3600
    const offset = limit * (page - 1)

    if (to.query.identityNo) query.identityNo = to.query.identityNo

    const params = Object.assign(
      query,
      { limit, offset }
    )
    try {
      const { items, count } = await getPackets(params)

      console.log(items[0])

      next(vm => {
        vm.packets = items
        vm.count = count
        vm.pagination.page = page
        vm.filters.identityNo = to.query.identityNo
      })
    } catch (err) {
      next()
    }
  },
  async beforeRouteUpdate (to, from, next) {
    try {
      await this.fetch(to)
      next()
    } catch (err) {
      next()
    } finally {
      this.loading = false
    }
  },
  methods: {
    async fetch (route) {
      this.loading = true
      const query = {}

      if (route.query.identityNo) query.identityNo = route.query.identityNo

      let page = parseInt(route.query.page, 10) || 1
      if (page < 1) page = 1
      const limit = 3600
      const offset = limit * (page - 1)

      const params = Object.assign(
        query,
        { limit, offset }
      )

      try {
        const { items, count } = await getPackets(params)

        this.packets = items
        this.count = count
      } finally {
        this.loading = false
      }
    },
    move (page) {
      if (page !== this.pagination.page) {
        this.pagination.page = page
        this.$router.push({ query: { ...this.$route.query, page } })
      }
    },
    toHexString (arr) {
      const hexes = arr.map(int => int.toString(16).toUpperCase().padStart(2, '0'))

      return hexes.join(' ')
    },
    filter () {
      this.$router.push({ query: this.filters })
    },
    dateFromObjectId (objectId) {
      return this.$moment(new Date(parseInt(objectId.substring(0, 8), 16) * 1000)).format('YY-MM-DD HH:mm:ss')
    },
    show (arr) {
      alert(this.toHexString(arr))
    }
  }
}
</script>
